/**
 * Only allow same-origin path redirects (prevents open redirects).
 * @param {string | null} path
 * @returns {string}
 */
export function getSafeRedirectPath(path) {
  if (!path || typeof path !== "string") return "/home";
  const trimmed = path.trim();
  if (!trimmed.startsWith("/")) return "/home";
  if (trimmed.startsWith("//")) return "/home";
  if (trimmed.includes("..") || trimmed.includes("//")) return "/home";
  if (trimmed.length > 512) return "/home";
  return trimmed;
}
